import { render } from "./SplashView.vue?vue&type=template&id=af6e4c60&scoped=true"
const script = {}

import "./SplashView.vue?vue&type=style&index=0&id=af6e4c60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af6e4c60"]])

export default __exports__